var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { FormProvider } from './context/Form.context';
import Form from './Form';
var FormComponent = function (_a) {
    var defaultInitialValues = _a.initialValues, children = _a.children, props = __rest(_a, ["initialValues", "children"]);
    var _b = useState(defaultInitialValues), initialValues = _b[0], setInitialValues = _b[1];
    var initialState = {
        values: initialValues || {},
        validationMessages: {},
        invalidFields: [],
    };
    return (React.createElement(FormProvider, { initialState: initialState },
        React.createElement(Form, __assign({ initialValues: initialValues || {} }, props), children)));
};
export default FormComponent;
